import { expVal } from '@atlassian/jira-feature-experiments';

const JiraAiLocalAgentSessionsEnabledRelayProvider = {
	get(): boolean {
		return expVal('deliveroo-team-sessions-local-session', 'isEnabled', false);
	},
};

export default JiraAiLocalAgentSessionsEnabledRelayProvider;
